import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-files",
  "use": "icon-files-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 18\" id=\"icon-files\">\n    <path fill=\"currentColor\" d=\"M0 0v18h14V4.56L9.39 0H0zm1.4 1.385h7v4.153h4.2v11.077H1.4V1.385zm8.4.979l1.81 1.79H9.8v-1.79zM3.5 7.615V9h1.4V7.615H3.5zm2.8 0V9h1.4V7.615H6.3zm2.8 0V9h1.4V7.615H9.1zm-5.6 2.77v1.384h1.4v-1.384H3.5zm2.8 0v1.384h1.4v-1.384H6.3zm2.8 0v1.384h1.4v-1.384H9.1zm-5.6 2.769v1.385h1.4v-1.385H3.5zm2.8 0v1.385h1.4v-1.385H6.3zm2.8 0v1.385h1.4v-1.385H9.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol